import { TSpeciality, TBranch } from "views/public/Doctors/Doctors.types";
import { TSelectOption } from "global.types";

export function composeSpecialitiesOptions(
  specialities?: TSpeciality[]
): TSelectOption[] {
  return (
    specialities?.map((speciality: TSpeciality) => {
      return { label: speciality?.title || "", value: speciality?.id };
    }) || []
  );
}

export function composeBranchesOptions(branches?: TBranch[]): TSelectOption[] {
  return (
    branches?.map((branch: TBranch) => {
      return { label: branch?.title || "", value: branch?.id };
    }) || []
  );
}
